<script lang="ts" setup>
import { Policy } from '@/interfaces/policy';
import useCountryCodes from "@/composables/useCountryCodes";

interface Props {
    policy?: Policy
}

const props = defineProps<Props>();

const { countryCodes } = useCountryCodes({ params: { ids: props.policy?.rule[0].options } });



</script>

<template>
    <div>
        <ul class="">

            <li v-for="country in countryCodes" :key="country.id">
                <div class="flex gap-1 text-sm">
                    <p> {{ country.emoji }}</p>
                    <p> {{ country.name }}</p>
                </div>
            </li>
        </ul>
    </div>
</template>
  
  

  